export default class MessagesApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  updateReaction({ conversationId, messageId, reactionId }, params, httpConfig) {
    return this.httpPut(
      `conversations/${conversationId}/reactions/${messageId}`,
      { reaction: reactionId },
      params,
      httpConfig
    );
  }
}
